import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BillingType } from '@pedix-workspace/utils';

@Injectable({
  providedIn: 'root',
})
export class StripeCouponCodeService {
  private http = inject(HttpClient);
  
  constructor() {}

  validateCoupon(apiUrl: string, promotionCode: string, billingType: BillingType) {
    return this.http.get(`${apiUrl}/stripe/promotion-code/${promotionCode}/${billingType}`);
  }
}
